var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "url(#paint0_linear_6256_72732)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 10.9683C6.4375 12.0595 7.28127 12.937 8.31627 12.937H10.4312C11.3312 12.937 12.0625 12.172 12.0625 11.2158C12.0625 10.192 11.6125 9.82078 10.9488 9.58453L7.5625 8.40328C6.89875 8.16703 6.44876 7.80703 6.44876 6.77203C6.44876 5.82703 7.17999 5.05078 8.07999 5.05078H10.195C11.23 5.05078 12.0738 5.92828 12.0738 7.01953",
    stroke: "url(#paint1_linear_6256_72732)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.9375V14.0625",
    stroke: "url(#paint2_linear_6256_72732)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6256_72732",
    x1: 9.25,
    y1: 0,
    x2: 9.25,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6256_72732",
    x1: 9.25563,
    y1: 5.05078,
    x2: 9.25563,
    y2: 12.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6256_72732",
    x1: 9.75,
    y1: 3.9375,
    x2: 9.75,
    y2: 14.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyIcon);
export default __webpack_public_path__ + "static/media/currency-icon.80e087a15e7fbdc9caa6b250153cf4c4.svg";
export { ForwardRef as ReactComponent };